import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import ReferralArchiveWarning from '../../components/modal/ReferralArchiveWarning';
import { archiveReceivedRecords } from '../../actions/records';

class ReferralArchiveWarningDialog extends Component {
  render() {
    return (
      <div>
        <ReferralArchiveWarning
          {...this.props}
        />
      </div>
    );
  }
}

ReferralArchiveWarningDialog.defaultProps = {
  archiveErrorMessage: '',
};

ReferralArchiveWarningDialog.propTypes = {
  archiveReceivedRecords: PropTypes.func.isRequired,
  archiveErrorMessage: PropTypes.string,
};

export default connect(state => ({
  isLoading: state.records.isLoading,
  archiveErrorMessage: state.records.archiveErrorMessage,
}), { archiveReceivedRecords })(ReferralArchiveWarningDialog);
